import ScrollOut from "scroll-out";

function setScrollOut(){

  ScrollOut({
    targets: ".site-content",
    offset: 10
  });

  ScrollOut({
    targets: "body",
    offset: window.screen.height
  });

}
setScrollOut();
